export default __webpack_public_path__ + "static/akzidenz-grotesk-bold-06af2a9a19f9d9b5b8c8997b7fdaceef.woff2";